import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FormActivity, FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";

import { selectHasNeededPermissions } from "../../../utilities/user";
import { hasUpdateDocumentPermission } from "../../../utilities/permissionUtils";

import { isDocumentWithCorrelatedFachverfahrenKey } from "../textbausteineTypeGuard";

export const setTextbausteinFormReadonlyMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	if (
		!ActivityActions.setData.match(action) ||
		!FormActivity.Data.SingleDocumentData.isInstance(action.payload.data) ||
		(action.payload.data.document.modelId !== "Text_D" &&
			action.payload.data.document.modelId !== "Kategorien_D") ||
		!isDocumentWithCorrelatedFachverfahrenKey(action.payload.data.document)
	) {
		return next(action);
	}
	const fvKey = action.payload.data.document.root.correlatedFachverfahrenKey;
	const hasPermission = selectHasNeededPermissions(hasUpdateDocumentPermission, fvKey)(api.getState());
	if (!hasPermission) {
		api.dispatch(
			FormEngineActions.command({
				activityId: action.payload.activityId,
				engineEvent: Commands.setReadonly(true)
			})
		);
	}
	return next(action);
});
